<template>
    <div ref="tile" class="tileinfo">
        <div v-if="!isEditMode && showheader" class="d-flex flex-row align-items-center py-3 border tileborder" v-bind:class="adderrorborder?'border-color-red':''">
            <i :class="tileicon + ' icon mx-2 mx-lg-3 d-none d-sm-inline'" :aria-label="tileHeader"></i>
            <div class="mr-auto ml-2 ml-sm-none">
                <div class="h5">{{tileHeader}}</div>
                <div v-if="showtitlebody" class="label">{{tilebod}} <slot name="subicononclose"></slot></div>
            </div>
            <div class="mr-2 mr-md-3">
                <button :disabled='isparenterrorset' @click="isEditMode=!isEditMode" type="button"
                        class="btn btn-outline-primary col text-center buttonlabel edit">
                    {{ editText }}
                </button>
            </div>
        </div>
        <div v-if="isEditMode && showheader" class="d-flex flex-row align-items-center py-3
             border border-bottom-0 rounded-top tileborder" v-bind:class="adderrorborder?'border-color-red':''">
            <div class="mx-2 mx-lg-3">
                <i :class="tileicon + ' icon colorwhite'" :aria-label="tileHeader"></i>
            </div>

            <div class="mr-auto" :aria-label="tileHeader">
                <div class="h5 colorwhite mb-0">{{tileHeader}} <slot name="subicononopen"></slot></div>
            </div>
        </div>
    <div v-show="isEditMode" class='border'>
        <div v-bind:class="'px-2 px-md-3 py-3' + (isseparatepage ? '' : ' d-flex flex-column')">
            <div>
                <slot name="component"></slot>
            </div>
            <div>

                <div  v-if="isemail" v-bind:class="(!isseparatepage? 'd-flex flex-row-reverse' : 'col col-md-6 pl-0')">
                    <button v-if="!issavingdata" :disabled='isSaveDisabled || savingdata' type="button"
                            @click="$emit('onsave');issavingdata=true;"
                            v-bind:class="'btn btn-primary px-4 noborder save ' + (isseparatepage ? 'w-100' : 'float-right')">
                        <slot name="savebuttontitle">
                            <span>Save Changes</span>
                        </slot>
                    </button>
                    <button v-if="issavingdata" type="button" v-bind:class="'btn btn-primary px-4 noborder save ' + (isseparatepage ? 'w-100' : 'float-right')">
                        <slot name="savingbuttontitle">
                            <span>{{contentblocks.saving}}</span>
                        </slot>
                        <i class="far fa-circle-notch fa-spin"></i>
                    </button>
                    <button v-if="!isseparatepage" @click="cancel" type="button" class="btn btn-link mr-3 buttonlabel noborder cancel">Cancel</button>
                </div>
            </div>
        </div>
    </div>
    </div>

</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'contactinfo-tile',
        props: {
            isemail: false,
            tileicon: "",
            tileHeader: "",
            tileBody: "",
            editmodel: {},
            parentmodel: {},
            watchers: {},
            componenterr: false,
            openedit: false,
            savingdata: false,
            renderheader: true,
            prioritizederrors: Array,
            errorpriority: 0,
            parenterrorpriorities: Array,
            isseparatepage: { default: false },
            showtitlebody: { type: Boolean, default: true },
            contentblocks: {},
        },
        computed: {
            editText: function(){
                return this.isemail ? "Change Email" : "Change Password";
            }
        },
        watch: {
           tileBody: {
                handler() {
                    this.renderbod();
                },
            },
            savingdata: {
                handler(val) {
                    if (val === false && this.issavingdata) {
                        this.issavingdata = false;
                        this.isSaveDisabled = true;
                        this.isEditMode = false;
                        this.$emit('isclean');
                        this.$emit('oncancel');
                    }
                },
            },
            componenterr: {
                handler(val) {
                    if (val === true) {
                        this.isSaveDisabled = true;
                        this.addremoveerrorborder(true);
                    }
                    else {
                        this.addremoveerrorborder(false);
                    }
                },
            },
            "openedit": {
                handler(val) {
                    this.isEditMode = val;
                },
            },
            isdirty: {
                handler(newValue,oldValue) {
                    if (newValue != oldValue) {
                        if (newValue) {
                            this.$emit('isdirty');
                        }
                        else {
                            this.$emit('isclean');
                        }
                    }
                },
            },
            prioritizederrors: {
                handler(val) {
                    if (this.errorpriority > 0 && val.length > 0 && val[0] == this.errorpriority) {
                        this.isEditMode = true;
                        this.$refs.tile.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        var focuselement = $(this.$refs.tile).children().find('[class*="is-invalid"]').first();
                        if (focuselement && focuselement.focus) {
                            this.$nextTick(function () {
                                focuselement.focus();
                            })
                        }
                    }
                    else {
                        if (this.parenterrorpriorities && this.parenterrorpriorities.length > 0) {
                            this.isparenterrorset = val.some(r => this.parenterrorpriorities.indexOf(r) >= 0)
                            this.addremoveerrorborder(!this.isparenterrorset && this.componenterr);
                        }
                    }
                },
            }
        },
        created: function () {
         
            if (this.renderheader === false) {
                this.showheader = false;
            }
            this.isEditMode = this.openedit;
            this.renderbod();
            this.addwatchers();
        },
        mounted: function () {
           Vue.nextTick(() => this.$emit('inerrorstate', this.errorpriority, this.componenterr));
        },
        data: function () {
            return {
                isEditMode: false,
                tilebod: "",
                isSaveDisabled: true,
                issavingdata: false,
                showheader: true,
                isdirty: false,
                adderrorborder: false,
                isparenterrorset: false,
            }
        },
        methods: {
            cancel: function () {
                this.isEditMode = false; 
                this.isSaveDisabled = true;
                this.$emit('oncancel');
            },
            renderbod: function () {
                if(this.tileBody){
                    this.tilebod = this.tileBody.trim().replace('null', '').length > 0 ? this.tileBody : this.contentblocks.notListed
                }
            },
            addremoveerrorborder: function (add) {
                this.adderrorborder = add;
            },
            addwatchers: function () {
                if (!this.watchers || this.watchers.length ==0) {
                    this.$watch('editmodel', this.stringfunc);
                }
                else {
                    for (let i = 0; i < this.watchers.length; i++) {
                        this.$watch('editmodel.' + this.watchers[i], this.watcherfunc(this.watchers[i]));
                    }
                }
            },
            watcherfunc: function (key) {
                return function (newValue) {
                    this.isSaveDisabled = true;
                    if (newValue != this.parentmodel[key] && !this.componenterr) {
                        this.isSaveDisabled = false;
                    }
                    if (newValue != this.parentmodel[key]) {
                        this.isdirty = true;
                        this.addremoveerrorborder(false);
                    }
                    else {
                        this.isdirty = false;
                        if (this.componenterr) {
                            this.addremoveerrorborder(true);
                        }
                    }
                }
            },
            stringfunc: function (newValue) {
                this.isSaveDisabled = true;
                if (newValue != this.parentmodel && !this.componenterr) {
                    this.isSaveDisabled = false;
                }
                if (newValue != this.parentmodel) {
                    this.isdirty = true;
                    this.addremoveerrorborder(false);
                }
                else {
                    this.isdirty = false;
                    if (this.componenterr) {
                        this.addremoveerrorborder(true);
                    }
                }
            },
        }
    }
</script>